import React, {Component} from 'react';
import {connect} from "react-redux";

import Footer from '../../components/Footer';
import HeaderMemberVirtualGifts from '../../components/member/HeaderMemberVirtualGifts';

import VirtualGiftList from '../../components/virtualgift/VirtualGiftList';
import ModalViewVirtualGift from 'components/modals/ModalViewVirtualGift';

import {t} from '../../l10n';

import 'sass/member/MemberVirtualGifts.scss';

class MemberVirtualGifts extends Component {
    constructor(props) {
        super(props);

        this.state = {
            showModal: false,
            openedVirtualGift: null
        }
    }
    
    componentWillReceiveProps(nextProps) {
        if (this.state.openedVirtualGift) {
            this.setState({
                openedVirtualGift: nextProps.memberVirtualGifts.virtualGifts.filter((item) => item.id === this.state.openedVirtualGift.id)[0]
            })
        }
    }

    render() {
        let {memberVirtualGifts} = this.props,
            {giftRank, giftPoints, virtualGifts, totalCount} = memberVirtualGifts;

        return (
            <div id="wrapper">
                <HeaderMemberVirtualGifts />

                <ModalViewVirtualGift
                    show={this.state.showModal}
                    closeFn={() => this.setState({showModal: false})}
                    virtualGift={this.state.openedVirtualGift}
                />

                <aside className="mygifts">
                    <div className="content">

                        <div className="heading">
                            <h2>{t('My virtual gifts')} <em>{totalCount}</em></h2>

                            <div className="status">
                                {giftRank > 0 && <b className={'ic-star-small ic-star'+giftRank} />}
                                <i dangerouslySetInnerHTML={{__html: t('You have <strong>%1</strong> gift points', giftPoints)}}/>
                            </div>
                        </div>

                        <VirtualGiftList
                            actions
                            showDetails
                            viewMessage
                            openFn={(virtualGift) => this.setState({showModal: true, openedVirtualGift: virtualGift})}
                        />

                        <div className="footer-text">
                            <ul className="description">
                                <li>{t('Virtual gifts have a value defined by the number of points.')}</li>
                                <li>{t('Every received gift credits your virtual account with the number of gift points that reflect the value of the gift.')}</li>
                                <li>{t('Virtual gifts are permanently displayed on your profile.')}</li>
                                <li>{t('Gift points accumulated on your account are valid for 60 days and allow you to participate in the ranking of BobTV favorites.')}</li>
                                <li>{t('The more gift points you have the better status you get in the favourites of BobTV.')}</li>
                            </ul>

                            <ul className="statuses">
                                <li>{t('With 100 gift points you get a blue star')} <span className="ic-star1"/>.</li>
                                <li>{t('From 200 gift points you get a red star')} <span className="ic-star2"/> {t('and if you have over 500 gift points you receive a golden star')}<span className="ic-star3"/>.</li>
                            </ul>

                            <p className="hide-text">
                                <span className="icon-hide"/> {t('You can hide your virtual gifts, they will not be displayed on your profile and corresponding gift points will no longer be counted.')}
                            </p>
                        </div>

                    </div>
                </aside>

                <Footer />
            </div>
        )
    }
}

export default connect(
    state => ({
        memberVirtualGifts: state.memberVirtualGifts
    })
)(MemberVirtualGifts)


// WEBPACK FOOTER //
// ./src/containers/member/MemberVirtualGifts.js